import { __assign } from "tslib";
// DS3.5
import React, { useContext } from 'react';
import c from 'classnames';
import InputErrorMessage from '@wix/da-ds/pkg/formControls/lego/InputErrorMessage';
import InputLabelText from '@wix/da-ds/pkg/formControls/lego/InputLabelText';
import InputLabelSubText from '@wix/da-ds/pkg/formControls/lego/InputLabelSubText';
import FormElement from '@wix/da-ds/pkg/formControls/layouts/FormElement';
import ArrowDown from '@wix/da-ds/pkg/Icons/16x16/ArrowDown';
import ArrowUp from '@wix/da-ds/pkg/Icons/16x16/ArrowUp';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import NativeDropdown from '../../NativeDropdown';
import DropdownStateManager, { DropdownStateContext, } from '../../DropdownStateManager';
import noop from '../../../utils/noop';
import s from './SelectField.scss';
var SelectField = function (_a) {
    var id = _a.id, className = _a.className, label = _a.label, subLabel = _a.subLabel, isLabelHidden = _a.isLabelHidden, placeholder = _a.placeholder, items = _a.items, error = _a.error, _b = _a.onSelect, onSelect = _b === void 0 ? noop : _b;
    var selectListId = "".concat(id, "-list");
    var _c = useContext(DropdownStateContext), isOpen = _c.isOpen, setToggleRef = _c.setToggleRef;
    var value = items
        .filter(function (item) { return item.selected; })
        .map(function (item) { return item.label; })
        .join(', ');
    var Icon = isOpen ? ArrowUp : ArrowDown;
    return (React.createElement("div", { className: c(s['root'], isOpen && s['open'], error && s['error'], className) },
        React.createElement(FormElement, { inputId: id, label: React.createElement(InputLabelText, { className: "label" }, label), subLabel: React.createElement(InputLabelSubText, { className: "sublabel" }, subLabel), isLabelHidden: isLabelHidden, noBottomSpacing: true, details: error && (React.createElement(InputErrorMessage, { id: "".concat(id, "-error") }, error)) },
            React.createElement("div", { className: s['content'] },
                React.createElement("div", { id: id, tabIndex: 0, className: c(s['input'], 'ignore-react-onclickoutside'), ref: setToggleRef, role: "menu", "aria-controls": selectListId },
                    value && React.createElement("div", { className: s['value'] }, value),
                    !value && placeholder && (React.createElement("div", { className: s['placeholder'] }, placeholder)),
                    React.createElement(Icon, { className: s['icon'], size: IconSize.SMALLER, disableDefaultColors: true })),
                React.createElement("div", { className: s['native-dropdown-hidden'] },
                    React.createElement(NativeDropdown, { onSelect: onSelect, items: items }))))));
};
SelectField.displayName = 'SelectField';
var SelectFieldWithDropdownState = function (props) { return (React.createElement(DropdownStateManager, null,
    React.createElement(SelectField, __assign({}, props)))); };
export default SelectFieldWithDropdownState;
//# sourceMappingURL=SelectField.js.map